"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateContactDetailsDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const child_details_dto_1 = require("./child-details.dto");
const class_transformer_1 = require("class-transformer");
const validate_date_1 = require("../../../../../service-lib/src/lib/utils/validate-date");
class CreateContactDetailsDto {
}
exports.CreateContactDetailsDto = CreateContactDetailsDto;
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Gender should be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDetailsDto.prototype, "gender", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Date of birth must be a string." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Date of birth must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (0, validate_date_1.validatePastDate)(value, "Date of birth")),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "dateOfBirth", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Favourite food should be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Favourite food must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "favouriteFood", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Favourite restaurant should be a string" }),
    (0, class_validator_1.MaxLength)(100, {
        message: "Favourite restaurant must not exceed 100 characters",
    }),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "favouriteRestaurant", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "personal history should be a string" }),
    (0, class_validator_1.MaxLength)(500, {
        message: "Personal history must not exceed 500 characters",
    }),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "personalHistory", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "major achievements should be a string" }),
    (0, class_validator_1.MaxLength)(500, {
        message: "Major achievements must not exceed 500 characters",
    }),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "majorAchievements", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Marital status should be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDetailsDto.prototype, "maritalStatus", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Date of wedding should be a date." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Date of wedding must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (0, validate_date_1.validatePastDate)(value, "Date of wedding")),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "dateOfWedding", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Spouse name should be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Spouse name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "spouseName", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Spouse date of birth should be a date." }),
    (0, class_transformer_1.Transform)(({ value }) => value ? value.trim() : value),
    (0, class_validator_1.Matches)(/^\d{4}-\d{2}-\d{2}$/, {
        message: "Spouse date of birth must be in the format YYYY-MM-DD.",
    }),
    (0, class_transformer_1.Transform)(({ value }) => (0, validate_date_1.validatePastDate)(value, "Spouse date of birth")),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "spouseDateOfBirth", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Spouse working status should be a number" }),
    tslib_1.__metadata("design:type", Number)
], CreateContactDetailsDto.prototype, "spouseWorkingStatus", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Spouse working company should be a string" }),
    (0, class_validator_1.MaxLength)(100, { message: "Working company must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], CreateContactDetailsDto.prototype, "workingCompany", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: false }),
    (0, class_transformer_1.Type)(() => child_details_dto_1.CreateChildDetailsDto),
    (0, class_validator_1.IsOptional)(),
    tslib_1.__metadata("design:type", Array)
], CreateContactDetailsDto.prototype, "childDetails", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateContactDetailsDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], CreateContactDetailsDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], CreateContactDetailsDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], CreateContactDetailsDto.prototype, "updatedAt", void 0);
